module.exports = __webpack_public_path__ + "static/media/bg_login.fd60ea56.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/bg/bg_login.jpg
// module id = 608
// module chunks = 0